import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const Container = styled.div`
  padding: 18px 16px;

  @media (min-width: 1280px) {
    padding: 24px 0;
  }
`
export const Headline = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${Color.gray900};
  margin-bottom: 12px;
`

export const Body = styled.div`
  padding: 12px 0;
  display: grid;
  grid-template-columns: repeat(6, minmax(100px, 1fr));
  grid-gap: 16px;
  position: relative;

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(4, minmax(100px, 1fr));
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }

  @media screen and (max-width: 375px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media (min-width: 1280px) {
    grid-gap: 32px;
  }
`
